import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { KitchenBoardPage } from '@/features/hospitality/pages/KitchenBoardPage'

const searchSchema = z.object({
  tab: z.enum(['transfer', 'stock', 'stock-takes']).catch('transfer'),
})

export const Route = createFileRoute('/_app/hospitality/kitchen')({
  validateSearch: searchSchema,
  component: KitchenBoardPage,
})
